import * as React from 'react'
import AdjustButton from './AdjustButton'
import { separateTime } from '../helpers/time'

export type RecordMachineProps = {
  machine: any
  onAdjust?: (machine: any) => void
  className?: string
}

const RecordMachine: React.FC<RecordMachineProps> = ({ machine, onAdjust, className }) => {
  const [hours, minutes] = separateTime(Math.abs(machine.time))
  const sign = machine.time < 0 ? '-' : ''
  const timeStr = `${sign}${hours}:${minutes > 9 ? minutes : `0${minutes}`}`
  const details = [machine.machine.name, `${timeStr}`].filter(Boolean).join(', ')

  return (
    <div className={`card ${className || ''}`}>
      <div className="card-body p-2 d-flex justify-content-between align-items-center">
        <span>{details}</span>
        {onAdjust && <AdjustButton onClick={() => onAdjust(machine)} />}
      </div>
    </div>
  )
}

export default RecordMachine
